module.exports = __webpack_public_path__ + "images/c6630e3b84cd10c6f6c02fdb78a36097.svg";